<template>

<h6 class="secondary-title" v-if='total && isReady'>
    <span class="text-xs-small">Results found:</span>
    <span class="text-dblue">{{ total }}</span>
</h6>

</template>

<script>
    export default {

        mounted() {

            bus.$on('total-change', (t) => {
                this.total = parseInt( t );
                this.isReady = true;
            })
        },

        props : ['t'],

        created() {
            if( typeof this.t != 'undefined' ) {
                this.total = parseInt( this.t );
                this.isReady = true;
            }
        },

        data() { 

            return {
                isReady : false,
                total : 0,
            }
            
        },

        methods : {

        }

    }
</script>
